import Index from '../../views/main/regions/Index'
import Create from '../../views/main/regions/Create'
import Edit from '../../views/main/regions/Edit';

export default [
  {
    component: Index,
    name: 'regions-index',
    path: '/regions',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'regions',
    }
  },
  {
    component: Create,
    name: 'regions-create',
    path: '/regions/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'regions',
    }
  },
  {
    component: Edit,
    name: 'regions-edit',
    path: '/regions/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'regions',
    }
  },
]
